import React from 'react';
import { i18n } from 'utils/i18n';
import useActions from 'hooks/useActions';
import Modal from 'components/Modal';
import MODAL, { MODAL_THEMES } from 'constants/modals';
import { extrasComplete } from 'actions/reservation/extrasComplete';
import RecommendedExtrasAlertContent from 'components/modals/RecommendedExtrasAlertContent';

const RecommendedExtrasAlertModal = () => {
  const extrasCompleteAction = useActions(extrasComplete);
  return (
    <Modal
      modalKey={MODAL.RECOMMENDED_EXTRAS_ALERT_MODAL}
      header={i18n('recommended_alert_header_title')}
      theme={MODAL_THEMES.WHITE}
    >
      <RecommendedExtrasAlertContent onClickContinueToReview={extrasCompleteAction} />
    </Modal>
  );
};

export default RecommendedExtrasAlertModal;
